import React from 'react'
import PropTypes from 'prop-types'

export default function Label ({ htmlFor, required, children, extraText }) {
    return (
        <label htmlFor={htmlFor} className={'input-label'}>
            <span>
                { children }
                { (required && children) && (<span className={'input-asterisk'}>*</span>) }
            </span>
          {extraText && (
            <span
              className="input-label__extra"
              dangerouslySetInnerHTML={{ __html: extraText }}
            />
          )}
        </label>
    )
}

Label.propTypes = {
    htmlFor: PropTypes.string,
    required: PropTypes.bool
}